import React from 'react';

const INVESTOR_TOOLS = [
    { icon: '⚖', title: 'Corporate & Legal DD', body: 'Governance, cap table, IP assignment, contracts — read by AI in minutes.' },
    { icon: 'Σ', title: 'Financial Model AI', body: 'Model coherence, forecast discipline, and stress evidence, scored automatically.' },
    { icon: '⌥', title: 'Technical & Code DD', body: 'Architecture and code quality assessed without ever extracting source.' },
];

const COHORT_TOOLS = [
    { icon: '⚖', title: 'Self-diligence corporate & legal', body: "Find undocumented equity or IP gaps before an investor's AI does.*" },
    { icon: 'Σ', title: 'Build & reverse the model', body: 'Create an institutional-grade model, then stress-test it the way they will.*' },
    { icon: '⌥', title: 'Technical DD, no code extraction', body: "Score and remediate the stack before it's used as valuation leverage.*" },
];

const ToolGrid = ({ tools }) => (
    <div className="lp-acc-thesis-icons">
        {tools.map(t => (
            <div className="lp-acc-ti" key={t.title}>
                <div className="lp-acc-ti-icon" aria-hidden="true">{t.icon}</div>
                <h4>{t.title}</h4>
                <p>{t.body}</p>
            </div>
        ))}
    </div>
);

const AccReverseDiligenceSection = () => (
    <section className="lp-acc-sec lp-acc-sec--black">
        <div className="lp-acc-wrap">
            <span className="lp-acc-kicker" data-lp-reveal>The reverse-diligence principle</span>
            <h2 className="lp-acc-h2" data-lp-reveal data-lp-delay="60">If your investors are going to run AI diligence on your graduates, your graduates should run it on themselves first.</h2>
            <p className="lp-acc-sub" data-lp-reveal data-lp-delay="120">Diligentsia builds the diligence tools follow-on investors are adopting as standard. We give VCs the toolkit. Which means your cohort companies can use the identical toolkit on themselves — before an investor ever does — and walk into demo day already having remediated key issues.</p>

            <div className="lp-acc-thesis" data-lp-reveal data-lp-delay="160">
                <div className="lp-acc-thesis-half is-top">
                    <div className="lp-acc-thesis-cap">Deployed by follow-on investors</div>
                    <ToolGrid tools={INVESTOR_TOOLS} />
                </div>
                <div className="lp-acc-thesis-mid">reverse-diligenced, on the same platform</div>
                <div className="lp-acc-thesis-half is-bottom">
                    <div className="lp-acc-thesis-cap">Available to your cohort, first</div>
                    <ToolGrid tools={COHORT_TOOLS} />
                    <div className="lp-acc-thesis-footnote">* = partner integration</div>
                </div>
            </div>

            <p className="lp-acc-thesis-tagline" data-lp-reveal>Same tools. Same standard. <span>Whoever runs them first controls the negotiation.</span></p>
        </div>
    </section>
);

export default AccReverseDiligenceSection;
